// Google Tag Manager 및 광고 픽셀 관리

// Google Tag Manager 초기화
export const initGTM = () => {
  const GTM_ID = import.meta.env.VITE_GTM_ID;
  
  if (!GTM_ID) return;

  // GTM 스크립트 삽입
  const script = document.createElement('script');
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `;
  document.head.appendChild(script);

  // GTM noscript 삽입
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noscript, document.body.firstChild);
};

// Facebook Pixel 초기화
export const initFacebookPixel = () => {
  const FB_PIXEL_ID = import.meta.env.VITE_FB_PIXEL_ID;
  
  if (!FB_PIXEL_ID || FB_PIXEL_ID === 'XXXXXXXXXXXXXXXX' || window.fbq) return;

  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${FB_PIXEL_ID}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
};

// Naver Analytics 초기화
export const initNaverAnalytics = () => {
  const NAVER_ID = import.meta.env.VITE_NAVER_ANALYTICS_ID;
  
  if (!NAVER_ID) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '//wcs.naver.net/wcslog.js';
  document.head.appendChild(script);

  window.wcs_add = window.wcs_add || {};
  window.wcs_add['wa'] = NAVER_ID;
  
  if (window.wcs) {
    window.wcs.inflow();
    window.wcs_do();
  }
};

// 전환 이벤트 추적
export const trackConversionEvent = (eventName, parameters = {}) => {
  // Google Tag Manager DataLayer
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...parameters
    });
  }

  // Facebook Pixel
  if (window.fbq) {
    switch (eventName) {
      case 'form_submit':
        window.fbq('track', 'Lead', parameters);
        break;
      case 'contact_form_submit':
        window.fbq('track', 'Contact', parameters);
        break;
      case 'view_portfolio':
        window.fbq('track', 'ViewContent', parameters);
        break;
      default:
        window.fbq('trackCustom', eventName, parameters);
    }
  }

  // Naver Analytics
  if (window.wcs) {
    window.wcs.event(eventName, parameters);
  }
};

// 페이지 조회 추적 (SPA용)
export const trackPageViewAll = (path) => {
  // GTM
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'page_view',
      page_path: path,
    });
  }

  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }

  // Naver
  if (window.wcs) {
    window.wcs.inflow();
  }
};

// 리마케팅 태그 설정
export const setRemarketingTag = (productId, value) => {
  // Google Ads 리마케팅
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      'send_to': import.meta.env.VITE_GOOGLE_ADS_ID,
      'ecomm_prodid': productId,
      'ecomm_pagetype': 'product',
      'ecomm_totalvalue': value,
    });
  }
};